/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get, set } from 'lodash';

// Components
import MetaForm from 'shared/ui/components/form-components/MetaForm.vue';

const __vue_script__ = {
    name: 'GenericForm',

    components: {
        MetaForm
    },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            fields: [],
            fpType: null,
            model: {},
            ready: false
        };
    },

    async created() {
        let fpType = get(this.params, 'currentController.routeOptions.modelFpType');
        fpType = get(this.params, 'currentController.routeOptions.crudOpts.fpType', fpType);

        this.fpType = fpType;

        if (this.fpType) {
            const metadataForType = await this.$services.metadata.getMetadataForTypeAsArray(this.params.event._id, this.fpType);
            const allowSetFpExtId = get(this.params, 'currentController.routeOptions.allowSetFpExtId', false);
            const processedMetadataFieldsForType = this.$utils.metadata.filterDuplicateTargetsExceptionsFields(metadataForType);
            processedMetadataFieldsForType.forEach(field => { if (field.kind === 'external') { set(field, 'kind_options.showCreateButton', true); } });
            this.fields = processedMetadataFieldsForType;
            if (allowSetFpExtId) {
                processedMetadataFieldsForType.push({
                    field: 'fp_ext_id',
                    kind: 'fp_ext_id',
                    fpType: this.fpType,
                    eid: this.params.event._id,
                });
            }
        }

        await this.loadData();
    },

    methods: {
        /**
         * Load data for the current model if present.
         */
        async loadData() {
            try {
                const defaults = await this.$utils.controls.extractDefaults(this.fields, this.$services, this.params);
                console.info('[GenericForm] Fetching model...');
                const routeOptions = get(this.params, 'currentController.resolvers.default.options') || get(this.params, 'currentController.resolvers.crudItems.options');
                if (routeOptions) {
                    const { appscriptUrl, routeParam = 'modelId' } = routeOptions;
                    const routeParams = this.$router.getRouteParams();
                    const crudOpts = get(this.params, 'currentController.routeOptions.crudOpts');
                    const id = routeParams[routeParam] || routeOptions.id || crudOpts.queryId;

                    if (appscriptUrl) {
                        const data = await this.$services.appScripts.callAppScript(this.params.event._id, appscriptUrl, { id });
                        this.model = data;
                    } else {
                        const data = await this.$services.documents.getDocById(this.params.event._id, id);
                        this.model = data;
                    }
                } else {
                    this.model = {};
                }

                for (const field of this.fields) {
                    if (!this.model.hasOwnProperty(field.field)) {
                        this.model[field.field] = defaults[field.field];
                    }
                }

                this.ready = true;
            } catch (error) {
                console.error('[GenericForm] Error fetching model:', error);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c("meta-form", {
        staticClass: "generic-form",
        attrs: {
          value: _vm.model,
          fields: _vm.fields,
          event: _vm.params.event,
          "current-controller": _vm.params.currentController,
          "fp-type": _vm.fpType,
          "show-toolbar": true,
          context: _vm.params.event._id,
        },
        on: { reload: _vm.loadData, saved: _vm.loadData },
      })
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/pages/GenericForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__